<template>
    <div class="c-action-dots-menu d-flex justify-content-end ml-3">
        <b-dropdown left>
            <template slot="button-content">
                <span class="c-action-dots-menu__header d-block"><iconActionDotsMenu class="d-block"/></span>
            </template>

            <b-dropdown-item @click="openJoinClub()">
                {{ $t('requestToJoinClub') }}
            </b-dropdown-item>

            <b-dropdown-item :to="{ name: $options.ROUTES_CREATE_CLUB }">
                {{ $t('createClub') }}
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { JOIN_CLUB } from '@/constants/modals';
import { ROUTES_CREATE_CLUB } from '@/constants/routes';
import iconActionDotsMenu from '@/assets/img/account/action-dots-menu.svg?inline';

export default {
    components: {
        iconActionDotsMenu
    },

    ROUTES_CREATE_CLUB,

    methods: {
        ...mapActions(['setModalOpen']),

        openJoinClub() {
            this.$store.dispatch('setModalOpen', JOIN_CLUB);
        }
    }
};
</script>
